var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-layout-header',[_c('q-toolbar',{attrs:{"color":"primary","glossy":_vm.$q.theme === 'mat',"inverted":_vm.$q.theme === 'ios'}},[_vm._t("left"),_c('q-toolbar-title',{staticStyle:{"font-size":"2.2em"}},[_vm._v("\n        EPA Open Data Metadata Editor\n      ")]),_vm._t("right")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }